import { prop } from 'ramda';

import { usePageSelector } from '@core/js/store/hooks';

export const useIsLayoutRetailRegistrationWithoutHeader = () => {
    const pageLayout = usePageSelector(prop('pageLayout'));

    return pageLayout.name === '1-column-retail-registration-without-header';
};
